__turbopack_context__.v({
  "wrapper": "NextBlogNav-module__hLSYnG__wrapper",
});
